import React from "react";
import classes from "./MainLayout.module.css";

const MainLayout = ({ children }) => {
  return <div className={classes.main_container}>{children}</div>;
};

export default MainLayout;
